
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/make-your-1099",
      function () {
        return require("private-next-pages/make-your-1099.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/make-your-1099"])
      });
    }
  